import { render, staticRenderFns } from "./image_manage2.vue?vue&type=template&id=14074658&scoped=true"
import script from "./image_manage2.vue?vue&type=script&lang=js"
export * from "./image_manage2.vue?vue&type=script&lang=js"
import style0 from "./image_manage2.vue?vue&type=style&index=0&id=14074658&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14074658",
  null
  
)

export default component.exports